<template>
    <div class="question-bank">
        <div class="question-content">
            <SearchBox
                ref="searhBox"
                :select.sync="searchSelect"
                :content.sync="config.content"
            />
            <ItemSelect
                ref="quetionsType"
                name="题型"
                :options="optionsTiku"
                :select.sync="config.question_type"
                @onHeight="onHeight"
            />
            <ItemSelect
                name="难度"
                :options="optionsNandu"
                :select.sync="config.difficulty"
            />
            <TypeSelect
                ref="typeSelect"
                :options="optionsType"
                :select.sync="selectedType"
            />
            <BackBtn
                v-if="selectedType !== '0' && (config.chapter_id || config.knowledge_id)"
                :width="width"
                :form.sync="backForm"
                @onSuccess="onback"
            />
            <div class="content-data">
                <div v-if="cardData.length === 0" class="blank">
                    <img :src="$images.material.blank" alt="blank" />
                    <span class="name">暂无素材库</span>
                </div>
                <div v-else class="content-txts">
                <CardBox
                    ref="cardBox"
                    :width="width"
                    :data.sync="cardData"
                    :isBackBtn.sync="newIsBackBtn"
                    :questionTypeHeight.sync="questionTypeHeight"
                    @onFeedBack="$emit('onFeedBack', $event)"
                />
                <div class="footer-box-more">
                    <el-pagination
                        v-if="cardData && cardData.length>0"
                        :small="true"
                        background
                        layout="prev, pager, next"
                        :current-page.sync="newPageConfig.page"
                        :page-size="parseInt(newPageConfig.pageSize)"
                        :total="newPageConfig.total"
                        @current-change="currentChange"
                    >
                    </el-pagination>
                </div>
            </div>
            </div>
            <div class="box-shadow"></div>
        </div>
        <div class="more-search" :style="!newIsArticleCatalog?'width: 0px;':''">
            <AticleCatalog
                ref="articleCatalog"
                :isShowMenu="isShowMenu"
                :catalog_id.sync="catalog_id"
                :subject_id.sync="config.subject_id"
                :grade_id.sync="config.grade_id"
                :unitSelectedParents.sync="config.unitSelectedParents"
                :chapter_id.sync="config.chapter_id"
                :knowledge_id.sync="config.knowledge_id"
                :type.sync="selectedType"
                :isArticleCatalog.sync="newIsArticleCatalog"
                :navCatalogName.sync="navCatalogName"
                :unitName.sync="unitName"
                @flashData="flashData"
            />
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import {Loading} from 'element-ui'
    import SearchBox from './components/searchBox'
    import ItemSelect from './components/itemSelect'
    import TypeSelect from './components/typeSelect'
    import CardBox from './components/cardBox'
    import AticleCatalog from './components/articleCatalog'
    import BackBtn from './components/backBtn'
    import * as CommonServer from '../../../../../../api/common'
    import {articleTypeEmum} from '../../../../../../utils/enums'
    // 类型枚举
    const ArticleTypeEmum = articleTypeEmum
    const typeQuestion = [
        {id: 0, name: '全部'},
        {id: '56', name: '选择题'},
        {id: '57', name: '阅读题'},
        {id: '58', name: '作文'},
        {id: '60', name: '基础题'},
        {id: '130', name: '填空题'},
        {id: '131', name: '阅读判断'},
        {id: '132', name: '判断题'},
        {id: '55', name: '其他'}
    ]
    export default {
        name: "question-bank",
        components: {
            SearchBox,
            ItemSelect,
            TypeSelect,
            CardBox,
            AticleCatalog,
            BackBtn
        },
        props: {
            isArticleCatalog: Boolean,
            dragValue: [String, Number]
        },
        computed: {
            isShowMenu(){
                // 1.当类型为【选择教材章节】或【选择知识点】时，
                // 2.且章节目录有选中内容时
                // 3.以及章节被隐藏时出现
                let state = false
                if([ArticleTypeEmum.teach,ArticleTypeEmum.known].includes(this.selectedType) && !this.newIsArticleCatalog){
                    state = true
                }
                return state
            },
            backForm:{
                get() {
                    let arr = []
                    if (this.navCatalogName &&
                        [ArticleTypeEmum.teach].includes(this.selectedType)
                    ) arr.push({name: this.navCatalogName})
                    if (this.unitName) arr.push({name: this.unitName})
                    return arr
                },
                set(){

                }
            }
        },
        watch:{
            dragValue: {
                handler(){
                    this.getClacTypeWidth()
                },
                deep: true,
                immediate: true
            },
            isLoading:{
                handler(state){
                    const div = document.querySelector('.content-data')
                    if(state && div){
                        const options = {target: div, fullscreen: false}
                        this.loadingInstance = Loading.service(options);
                    } else {
                        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                            this.loadingInstance &&
                            this.loadingInstance.close &&
                            this.loadingInstance.close();
                        });
                    }
                },
                deep: true,
                immediate: true
            },
            searchSelect(vl){
                if(vl.length>2){
                    const arr = vl.split('/')
                    this.config.subject_id = arr[0]
                    this.config.grade_id = arr[1]
                    this.config.question_type = 0
                    this.config.difficulty = 0
                } else {
                    this.config.subject_id = ''
                    this.config.grade_id = ''
                }
                this.getTypes()
                this.clearSelectAll()

                this.calcQuestionTypeHeight()
            },
            isArticleCatalog(vl){this.newIsArticleCatalog = vl},
            newIsArticleCatalog(vl){
                this.$emit('update:isArticleCatalog', vl)
                this.getClacTypeWidth()
            },
            config: {
                handler(){
                    // this.isPage = false
                    clearTimeout(this.eventTimeout)
                    this.eventTimeout = setTimeout(()=>{
                        this.newPageConfig.page = 1
                        // this.isPage = true
                        this.flashData()
                        clearTimeout(this.eventTimeout)
                    }, 300)
                },
                deep: true
            },
            // 类别选择
            selectedType(vl, oldValue){
                if([ArticleTypeEmum.all].includes(vl)){
                    this.flashData()
                }
                if([ArticleTypeEmum.teach,ArticleTypeEmum.known].includes(vl)){
                    this.newIsArticleCatalog = true
                } else {
                    this.newIsArticleCatalog = false
                }

                const config = this.$_.cloneDeepWith(this.config)
                const backForm = this.$_.cloneDeepWith(this.backForm)

                this.historyRecord[oldValue] = {
                    backForm,
                    catalog_id: this.catalog_id,
                    ...config
                }
                if(this.navCatalogName) this.historyRecord[oldValue]['navCatalogName'] = this.navCatalogName
                if(this.unitName) this.historyRecord[oldValue]['unitName'] = this.unitName

                // 如果过滤条件不变 则恢复历史数据
                const newConfig = this.$_.cloneDeepWith(this.historyRecord[vl])
                const oldConfig = this.$_.cloneDeepWith(this.historyRecord[oldValue])
                // console.log(vl, newConfig, oldConfig)
                // debugger
                this.compareAandB(vl, newConfig, oldConfig)

                // this.clearSelectAll()
            }
        },
        created(){
            this.init()
        },
        data(){
            return {
                newIsBackBtn: '', // 是否有返回按钮
                historyRecord: {
                    [ArticleTypeEmum.all]: {},
                    [ArticleTypeEmum.teach]: {},
                    [ArticleTypeEmum.known]: {}
                },
                questionTypeHeight: 0, // 题目类型实际渲染高度
                navCatalogName: '', // 选中的教材版本名称
                unitName: '', // 选中的单元名称
                eventTimeout: null, // 截流
                contentLoading: true, // 内容加载
                searchSelect: '1/66', // 学科 & 年级
                catalog_id: '', // 教材章节选中目录
                // 搜索条件
                config: {
                    subject_id: '1', // 学科id
                    grade_id: '66', // 年级
                    unitSelectedParents: [], // 单元选中的所有父级节点
                    chapter_id: '', // 章节
                    knowledge_id: '', // 知识点
                    question_type: 0, // 题型
                    difficulty: 0, // 难易
                    content: '', // 搜索内容
                },
                // chapter_id: '',
                // knowledge_id: '',

                newIsArticleCatalog: this.isArticleCatalog,
                optionsTiku: typeQuestion,
                selectedTiku: '',
                optionsNandu: [
                    {id: 0, name: '全部'},
                    {id: 1, name: '容易'},
                    {id: 2, name: '中等'},
                    {id: 3, name: '较难'},
                ],
                selectedNandu: '',
                optionsType: [
                    {id: ArticleTypeEmum.all, name: '全 部'},
                    {id: ArticleTypeEmum.teach, name: '选择教材章节'},
                    {id: ArticleTypeEmum.known, name: '选择知识点'}
                ],
                selectedType: '0',
                // backForm: [
                //     {name: '人教版'},
                //     {name: '人教版'},
                //     {name: '人教版'}
                // ],
                isBackBtn: true,
                cardData:[
                    // {
                    //     id: '1',
                    //     tips: [
                    //         {name: '小学',type: 'blue'},
                    //         {name: '语文',type: 'green'},
                    //         {name: '选择题',type: 'violet'},
                    //         {name: '中等',type: 'browngreen'},
                    //     ],
                    //     question: '为加强高校学风建设，推进大学生就业指导工作,以下不正确 的是',
                    //     content: '',
                    //     selectOptions: [
                    //         {name: 'A', value: '引导学生为就业而树立远大的理想和职业'},
                    //         {name: 'B', value: '引导学生为就业而树立远大的理想和职业'},
                    //         {name: 'C', value: '引导学生为就业而树立远大的理想和职业'},
                    //         {name: 'D', value: '运用校园舞台，增强责任意识，将就业指导贯穿大学教育的 全过程'}
                    //     ],
                    //     answer: 'D',
                    //     isAnalysis: true,
                    //     analysis: '实施素质教育有赖于、或者说根本受制于教育工作者的任。有人说，孩子们的心就像一块奇妙的大地，播下的种子，会获得行为的，就会获得性格的收获。'
                    // },
                ],
                newPageConfig: {
                    page: 1,
                    pageSize: 5,
                    total: 1
                },
                isLoading: false, // 是否长在加载
                loadingInstance: null, // 加载数据

                width: '', // 类型总宽度，用来实时同步数据宽度
                fn: null
            }
        },
        methods:{
            ...mapActions(['setQuestionBankConfig']),
            init(){
                // 获取题型分类
                // this.getTypes()
                this.$nextTick(()=>{
                    this.getSelectedSubject()
                    this.flashData({})
                    this.getClacTypeWidth()
                })
            },
            // 获取历史选中学科
            async getSelectedSubject(){
                const res = await CommonServer.default.querySelectedSubject()
                console.log(res)
                if(res && res.data && res.data.items && res.data.items.length){
                    const {subject_id, grade_id} = res.data.items[res.data.items.length-1]

                    this.config.subject_id = subject_id
                    this.config.grade_id = grade_id

                    this.setQuestionBankConfig({
                        subject_id,
                        grade_id
                    })

                    this.$nextTick(()=>{
                        if(this.$refs.searhBox) {
                            this.$refs.searhBox.newSelect = `${subject_id}/${grade_id}`
                        }
                    })
                }
            },
            // 比较两个过滤条件
            compareAandB(newValue, newConfig, oldConfig){
              // 1.学科
              // 2.年级
              // 3.搜索框
              // 4.题型
              // 5.难度
              if(
                  newConfig.subject_id === oldConfig.subject_id &&
                  newConfig.grade_id === oldConfig.grade_id &&
                  newConfig.content === oldConfig.content &&
                  newConfig.question_type === oldConfig.question_type &&
                  newConfig.difficulty === oldConfig.difficulty
              ) {
                  // 去设置当前类别的历史值
                  switch (newValue) {
                      case ArticleTypeEmum.teach: {
                          // 去设置教师章节的 历史记录
                          console.log('教师历史', newConfig)
                          this.config.chapter_id = newConfig.chapter_id
                          this.config.unitSelectedParents = newConfig.unitSelectedParents
                          this.catalog_id = newConfig.catalog_id
                          this.navCatalogName = newConfig.navCatalogName
                          this.unitName = newConfig.unitName
                          break
                      }
                      case ArticleTypeEmum.known:
                          // 去设置知识点的 历史记录
                          console.log('知识点历史', newConfig)
                          this.config.knowledge_id = newConfig.knowledge_id
                          this.unitName = newConfig.unitName
                          break
                  }
              } else {
                  // 初始化当前过滤参数
                  this.clearSelectAll()
                  this.unitName = ''
                  this.navCatalogName = ''
              }
            },
            // 获取数据实时宽度
            getClacTypeWidth(){
                this.$nextTick(()=>{
                    clearTimeout(this.fn)
                    this.width = 0
                    this.fn = setTimeout(()=>{
                        // 获取类别的总宽度
                        if(this.$refs.typeSelect && this.$refs.typeSelect.$el.clientWidth>0) {
                            this.width = this.$refs.typeSelect.$el.clientWidth + 'px'
                        }
                        clearTimeout(this.fn)
                    }, 500)
                })
            },
            // 计算题型类型实际实时渲染高度
            calcQuestionTypeHeight(){
                this.$refs.quetionsType &&
                this.$refs.quetionsType.newCalcHeight &&
                this.$refs.quetionsType.newCalcHeight()
            },
            // 题型高度
            onHeight(height){
                this.questionTypeHeight = height
            },
            clearSelectAll(){
                // 清空章节选择
                // 清空知识点选择
                // this.catalog_id = ''
                this.config.chapter_id = ''
                this.config.knowledge_id = ''
                this.config.unitSelectedParents = []
            },
            async getTypes(){
                const res = await CommonServer.default.queryTypes({
                    subject_id: this.config.subject_id || '1',
                    grade_id: this.config.grade_id || '66'
                })
                let arr = res.data.map(v=>{
                    return {
                        ...v,
                        id: `${v.id}`,
                        name: v.type_name
                    }
                })
                // 排序
                if(arr.length) arr = arr.sort((a, b)=>b.order_index - a.order_index)
                arr = arr.filter(v=>`${v.subject_id}` === `${this.config.subject_id}`)

                if(arr && arr.length === 0){
                    this.optionsTiku = typeQuestion
                    return false
                }

                this.optionsTiku = [
                    {id: 0, name: '全部'},
                    ...arr
                ]
            },
            async flashData(){
                // this.$refs.cardBox &&
                // this.$refs.cardBox.loadStart &&
                // this.$refs.cardBox.loadStart()
                this.isLoading = true

                const loadEnd = ()=>{
                    // this.$refs.cardBox &&
                    // this.$refs.cardBox.loadEnd &&
                    // this.$refs.cardBox.loadEnd()

                    this.isLoading = false
                }

                try {
                    // 获取题库列表
                    const {
                        subject_id,
                        grade_id,
                        chapter_id,
                        knowledge_id,
                        question_type,
                        difficulty,
                        content
                    } = this.config
                    const res = await CommonServer.default.queryQuestions({
                        subject_id,
                        grade_id,
                        chapter_id: [ArticleTypeEmum.teach].includes(this.selectedType)?chapter_id: '',
                        knowledge_id: [ArticleTypeEmum.known].includes(this.selectedType)?knowledge_id: '',
                        question_type, // : encodeURIComponent(question_type),
                        difficulty,
                        content,
                        page: this.newPageConfig.page,
                        per_page: this.newPageConfig.pageSize
                    })
                    console.log(res)
                    this.cardData = res.data.items.map(v=>{
                        let detail = v.question && v.question.detail || {}
                        // 难度大于等于3都为较难
                        let enumDifficulty = v.question && v.question.difficulty
                        if(enumDifficulty>=3) enumDifficulty = 3
                        return {
                            grade_id: v.question && v.question.grade_id,
                            subject_id: v.question && v.question.subject_id,

                            id: v.id,
                            tips: [
                                {name: this.$enums.gradeEmum[v.question && v.question.grade_id], type: 'blue'},
                                {name: this.$enums.subjectEmum[v.question && v.question.subject_id], type: 'green'},
                                {name: v.question && v.question.question_type_detail && v.question.question_type_detail.type_name, type: 'violet'},
                                {name: this.$enums.difficultyEmum[enumDifficulty], type: 'browngreen'},
                            ],
                            // question: detail.question_text,
                            selectOptions: [],
                            content: this.searchKey(detail.content),
                            answer: this.searchKey(detail.answer),
                            isAnalysis: false,
                            analysis: this.searchKey(detail.analysis)
                        }
                    })
                    this.newPageConfig = {
                        page: res.data.meta.current_page,
                        pageSize: res.data.meta.per_page,
                        total: res.data.meta.total
                    }
                    const div = document.getElementById('cardBox2')
                    if(div) {
                        const fn = setTimeout(()=>{
                            div.scrollTop = 0
                            clearTimeout(fn)
                        }, 200)
                    }
                }catch (e) {
                    console.log('获取失败==>', e)

                    loadEnd()
                }

                loadEnd()
            },
            searchKey(content){
              if(!content || !this.config.content){
                  return content
              }
              return content.replace(new RegExp(this.config.content,'g'),`<span style="background-color:#e7622e">${this.config.content}</span>`)
            },
            onback(){
                console.log('返回==>')
                // this.config.chapter_id = ''
                // this.config.knowledge_id = ''
                this.$refs.articleCatalog &&
                this.$refs.articleCatalog.curClearAll &&
                this.$refs.articleCatalog.curClearAll()
            },
            currentChange(curPage) {
                console.log("获取当前分页", curPage);
                this.newPageConfig.page = curPage
                this.flashData()
            }
        }
    }
</script>

<style lang="scss" scoped>
.question-bank{
    display: flex;
    flex-direction: row;
    flex: 1;
    height: 100vh;

    .question-content {
        display: flex;
        flex-direction: column;
        flex: 1;
        height: 100vh;
        width: 100%;
        position: relative;
        width: calc(100% - 330px);

        .box-shadow {
            position: absolute;
            top: 0px;
            right: 0px;
            height: calc(100vh - 55px);
            width: 16px;
            background: url("../../../../../../assets/images/resource/global/shadow1.png") repeat;
            z-index: 10;
            pointer-events: none;
        }
        .blank {
            display: flex;
            flex: 1;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            img {
                width: 120px;
                object-fit: contain;
            }

            .name {
                margin-top: 13px;
                font-size: 14px;
                font-weight: 400;
                color: #303133;
                line-height: 20px;
                position: relative;
                left: -6px;
            }
        }

        .footer-box-more {
            display: flex;
            padding: 0px 20px;
            flex-direction: row;
            justify-content: center;
        }
    }

    .more-search{
        display: flex;
        flex-direction: column;
        width: 330px;
        height: 100vh;
        transition: width .2s linear;
    }
}
</style>
